/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEndpoint = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M16 6a4.002 4.002 0 0 1-3 3.874v4.148c1.91.085 3.655.413 5.008.92.79.296 1.498.673 2.027 1.142.528.468.965 1.113.965 1.916s-.438 1.448-.965 1.916c-.53.469-1.238.846-2.027 1.142-1.586.595-3.71.942-6.008.942-2.297 0-4.422-.347-6.008-.942-.79-.296-1.498-.673-2.027-1.142C3.437 19.448 3 18.803 3 18s.437-1.448.965-1.916c.53-.469 1.238-.846 2.027-1.142 1.353-.507 3.098-.835 5.008-.92V9.874A4.002 4.002 0 0 1 12 2a4 4 0 0 1 4 4zm-4-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-1 12.024c-1.708.084-3.207.379-4.306.791-.658.247-1.121.517-1.402.765-.282.25-.292.395-.292.42s.01.17.292.42c.28.248.744.518 1.402.765C8.004 19.675 9.88 20 12 20s3.997-.324 5.306-.815c.658-.247 1.121-.517 1.402-.765.282-.25.292-.395.292-.42s-.01-.17-.292-.42c-.28-.248-.744-.518-1.402-.765-1.1-.412-2.598-.707-4.306-.79V18h-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgEndpoint as Endpoint };
